module.exports = __webpack_public_path__ + "img/pingray.fe5c1504.svg";